import {useTranslation} from "react-i18next";
import {useContext, useEffect, useRef, useState} from "react";
// -
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import NavBreadcrum from "components/NavBreadcrum";
import AuthContext from "context/AuthContext";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "views/utils/buttonsActions";
import axiApi from "ApiCaller";
import navs from "./navs";
import {DeviceConfig} from "site-apps/devices/DeviceConfig";
import TableConfig from "./groups-profiles/TableConfig";
import PreviewConfig from "./groups-profiles/PreviewConfig";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import useCustomTranslation from "core/customTranslation";
import {translations} from "./translations";
import OrderingModel from "components/ordering/OrderingModel";

const ViewGroupsProfiles = () => {
    const {user} = useContext(AuthContext);
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useCustomTranslation(translations);
    const bread = [
        {
            name: _Tr("labels.device-configuration"),
            url: "/device-configuration/",
            current: false,
        },
        {name: _Tr("configuration.groups-profiles"), current: true},
    ];
    const AlertQuestion = new SwalAlertChoice({
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    });
    document.title = _Tr("configuration.groups-profiles");
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});

    const items = useRef(new ItemsModel());
    const params = useRef({
        models: [],
    });

    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);

    const [item, setItem] = useState({...DeviceConfig});
    const [checkedAll, setCheckedAll] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [ships, setShips] = useState([]);
    const [models, setModels] = useState([]);
    const [sensors, setSensors] = useState([]);
    const [alerts, setAlerts] = useState([]);
    const [buttonsTB, setButtonsTB] = useState(() => {
        const buttonsAct = new ButtonsActions();
        buttonsAct.title = document.title;
        return buttonsAct;
    });
    const orderingRef = useRef(new OrderingModel());
    // data table
    const [itemsShown, setItemsShown] = useState([]);
    const headersTable = [
        {name: _Tt("devices.profiles_name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tc("table.default"), attr: 1, direction: "asc", active: false},
        {name: _Tc("table.model"), attr: 2, direction: "asc", active: false},
        {name: _Tc("table.measurement"), attr: 3, direction: "asc", active: false},
        {name: _Tc("table.sensors"), attr: 4, direction: "asc", active: false},
        {name: _Tc("table.alerts"), attr: 5, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = document.title;

        if (user.is_admin) {
            buttons.add.active = true;
            buttons.add.onClick = onClickAdd;
            buttons.add.disabled = false;
            buttons.delete.active = true;
            buttons.delete.onClick = onCLickDelete;
        }
        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            applyFilters();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => {
            applyFilters();
        };
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPreview;
        items.current.item = DeviceConfig;

        fetchGetData();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        const buttons = {...buttonsTB};
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        applyFilters();
    };

    function onClickAdd() {
        let item_ = {...DeviceConfig};
        item_.model = params.current.models[0];
        setItem(item_);
        setShowPreview(true);
    }

    function onCLickDelete() {
        AlertQuestion.fire("Atención", "Se borrarán el modo o los modos selecionados").then((quest) => {
            if (quest.isConfirmed) {
                deleteItems();
            }
        });
    }

    function deleteItems() {
        setIsLoading(true);
        let itemsDelete = items.current.getChosenIds();
        axiApi
            .delete(`/api/devices/config/`, {data: {ids: itemsDelete}})
            .then((r) => {
                if (r.data.status) {
                    items.current.showed = items.current.showed.filter((power) => !itemsDelete.includes(power.id));
                    items.current.all = items.current.all.filter((power) => !itemsDelete.includes(power.id));
                    setItemsShown([...items.current.showed]);

                    Alert.success(_Tc("message.success.title"), _Tc("message.register.delete.success"));
                } else {
                    Alert.warning(_Tc("preview.error"), _Tc("message.delete.error.text"));
                }
            })
            .catch((err) => {
                console.error("Error al enviar la solicitud:", err);
                Alert.error(_Tf("errors.not-permitted"), err.response.data.message);
            })
            .finally(() => {
                setIsLoading(false);
                items.current.clearChosen();
                setShowPreview(false);
                const buttons = {...buttonsTB};
                buttons.delete.disabled = true;
                setButtonsTB(buttons);
            });
    }

    const fetchGetData = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.get(`/api/devices/configs/`);

            if (resp.data.pager) {
                pagerModelRef.current.paging.update(resp.data.pager);
            }

            if (resp.data) {
                items.current.showed = [...resp.data.items];
                setItemsShown([...items.current.showed]);
                setShips([...resp.data.params.ships]);
                setModels([...resp.data.params.models]);
                params.current.models = [...resp.data.params.models];
                setSensors([...resp.data.params.sensors]);
                setAlerts([...resp.data.params.alerts]);
            } else {
                console.error("Error en devicesDefaults.api()");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setIsLoading(false);
    };

    const applyFilters = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.post(`/api/devices/configs/`, filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            });

            if (resp.data.pager) {
                pagerModelRef.current.paging.update(resp.data.pager);
            }

            if (resp.data) {
                items.current.setShowed(resp.data.items);
                setItemsShown([...resp.data.items]);
            } else {
                console.error("Error en devicesDefaults.api()");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableConfig
                            items={items}
                            itemsShow={itemsShown}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            checkAll={checkedAll}
                            setCheckAll={setCheckedAll}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                {showPreview ? (
                    <PreviewConfig
                        items={items}
                        item={item}
                        isSuperUser={user.is_admin}
                        models={models}
                        ships={ships}
                        sensors={sensors}
                        alerts={alerts}
                        setItemsShown={setItemsShown}
                        onClickDelete={onCLickDelete}
                        showPreview={showPreview}
                        setShowPreview={setShowPreview}
                    />
                ) : (
                    <> </>
                )}
            </div>
        </>
    );
};
export default ViewGroupsProfiles;
